import * as React from 'react';
import './LocationsButton.scss';
import { goToLocations, locationsUrl } from 'src/utils/navigation';
import locationIcon from 'src/assets/locationIcon';

export function LocationsButton(props: any) {
  const { t } = props;
  return (
    <div className="rp-locations-button--div">
      <a href={locationsUrl()} className="rp-locations-button--link">
        <div className="rp-locations-button no-select" onClick={goToLocations}>
          <img src={locationIcon} alt="Go to Cart" className="location-icon" />
          <div className="rp-locations-button--label">
            {t('common.locationTxt')}
          </div>
        </div>
      </a>
    </div>
  );
}
